import React from 'react';
import { ReactQueryProvider } from '@/utils/ReactQuery';
import { SPAThemeScope } from '@/components/admin/SysadminSPA/shared/SPAThemeScope';
import StatusPill from './StatusPill';
import { SlideStatus, useSlideStatuses } from './useSlideStatuses';

interface SlideStatusPillProps {
  initialNotes?: SlideStatus[];
  slideId: number;
}

/** The pill alone, for a parent that already provides the query client and theme scope. */
export const NewestStatus = ({ initialNotes, slideId }: SlideStatusPillProps) => {
  const { data: notes } = useSlideStatuses(slideId, initialNotes);
  const newest = notes?.[0];

  if (!notes) return null;
  if (!newest) return <span className="tw-text-spa-tertiary">—</span>;

  return <StatusPill status={newest.status} />;
};

// The Status cell of a slide row. It shares the query cache with the SlideAdminNotes mount in the
// Notes cell of the same row, so a note added there updates this pill without a page reload.
const SlideStatusPill = (props: SlideStatusPillProps) => (
  <ReactQueryProvider>
    <SPAThemeScope className="spa-theme-light">
      <span className="spa-theme-light tw-font-tci">
        <NewestStatus {...props} />
      </span>
    </SPAThemeScope>
  </ReactQueryProvider>
);

export default SlideStatusPill;
